import styled from 'styled-components';
import { Grid } from 'semantic-ui-react';

const NoPaddingColumn = styled(Grid.Column)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

export default NoPaddingColumn;
